import { SelfServiceAPI } from 'types';

export const errorStates: SelfServiceAPI.AmendmentState[] = ['FAILED', 'BLOCKED', 'INVALID'];
